import { __ } from "@wordpress/i18n";
import { RichText, useBlockProps, InnerBlocks } from "@wordpress/block-editor";
import { GeneralButton, AgendarCitaButton } from "../components/generalButton";
import React from "react";

const Save = (props) => {
	const blockProps = useBlockProps.save();
	const homeUrl = "/dr-carlos-gamboa/"; // Reemplaza con la URL correcta

	const { className, attributes, setAttributes } = props;
	const {
		imageUrlMobile,
		imageUrl,
		cgdescription,
		WHATSME_URL,
		cgtitle,
		cgsubtitle,
	} = attributes;
	return (
		<div
			{...blockProps}
			className="cg-blocks-wrapper-class relative banner bg-cgBlue"
		>
			<figure className="overflow-hidden">
				<picture>
					<source media="(min-width: 768px)" srcSet={`${imageUrl}`} />
					<img
						className="h-full lg:max-w-full w-full md:h-[unset] max-w-none lazyload"
						data-src={`${imageUrlMobile}`}
						alt=""
					/>
				</picture>
			</figure>

			<div className="absolute top-0 bottom-0 left-0 right-0 flex">
				<div className="flex flex-col m-auto md:ml-[12%]">
					<RichText.Content
						tagName="span"
						placeholder="subtitle"
						className="cgsubtitle pl-4 text-xl italic font-normal text-center md:text-left text-cgWhite"
						value={cgsubtitle}
					/>
					<RichText.Content
						tagName="span"
						placeholder="Title"
						className="cgtitle text-6xl italic text-center md:text-left md:text-7xl text-cgWhite font-cinzel"
						value={cgtitle}
					/>
					<RichText.Content
						tagName="span"
						placeholder="descripción"
						className="cgdescription pl-4 text-xl italic font-normal text-center md:text-left text-cgWhite"
						value={cgdescription}
					/>
					<div className="flex flex-col my-6 md:justify-center md:flex-row md:items-center">
						<div>
							<GeneralButton description="Saber más" url={homeUrl} />
						</div>
						<div className="inner-blocks-container">
							<InnerBlocks.Content />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Save;
